import './skeleton.css'

type TransactionsSkeletonProps = {
  rows: number
}

export default function TransactionsSkeleton({ rows }: TransactionsSkeletonProps) {
  const skeletonRows = Array.from({ length: rows })

  return (
    <div className='flex flex-col gap-8 w-full mt-2'>
      {skeletonRows.map((_, index) => (
        <div key={index} className='flex justify-between'>
          <div className='flex gap-4 items-center'>
            <div className='skeleton rounded-[8px] w-[37px] h-[21px]' />
            <div className='flex flex-col gap-[5px]'>
              <div className='skeleton w-[120px] h-[16px]' />
              <div className='skeleton w-[80px] h-[14px]' />
            </div>
          </div>
          <div className='flex flex-col items-end gap-[5px] flex-1'>
            <div className='skeleton w-[50%] h-[16px]' />
            <div className='skeleton w-[80%] h-[14px]' />
          </div>
        </div>
      ))}
    </div>
  )
}
